
export const saveToLocalStorage = (value, name) => {
  localStorage.setItem(name, JSON.stringify(value))
  localStorage.setItem('lastSaved', new Date())
}

export const restoreFromLocalStorage = (name) => {
  const config = localStorage.getItem(name)
  return config ? JSON.parse(config) : ''
}
